"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _animations = require("../assets/animations");

var _Constant = require("../Constant");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  z-index: 2000;\n  background-color: rgba(255, 255, 255, 0.7);\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents.default.div(_templateObject());

var Header = _styledComponents.default.h1(_templateObject2());

var Loader = function Loader(_ref) {
  var message = _ref.message,
      mode = _ref.mode;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement("div", null, function () {
    switch (mode) {
      case _Constant.Themes.CALIBER:
        return /*#__PURE__*/_react.default.createElement(_animations.CaliberLogo, null);

      case _Constant.Themes.HOMEBRIDGE:
        return /*#__PURE__*/_react.default.createElement(_animations.HomebridgeLogo, null);

      case _Constant.Themes.HOMEPOINT:
        return /*#__PURE__*/_react.default.createElement(_animations.HomepointLogo, null);

      case _Constant.Themes.SYNERGY_ONE:
        return /*#__PURE__*/_react.default.createElement(_animations.SynergyOneLogo, null);

      case _Constant.Themes.GUARANTEED_RATE:
        return /*#__PURE__*/_react.default.createElement(_animations.GuaranteedRateLogo, null);

      default:
        return /*#__PURE__*/_react.default.createElement(_animations.FigureLogo, null);
    }
  }(), message && /*#__PURE__*/_react.default.createElement(Header, null, message)));
};

Loader.propTypes = {
  /** A message to display with the loader */
  message: _propTypes.default.string,
  mode: _propTypes.default.string
};
Loader.defaultProps = {
  message: '',
  mode: 'figure'
};
var _default = Loader;
exports.default = _default;